module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1134"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1134"
    },
    "bundlingPackage": "LoginUI",
    "bundlingPackageVersion": "static-1.14996",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};